/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

const useStyles = makeStyles()(theme => {
  const themePalette = Tokens.colors[`${theme.palette.mode}Theme`];
  return {
    root: {
      height: '100%',
      '& .MuiListItemText-root.MuiListItemText-inset': {
        paddingLeft: Tokens.spacing['$sp-4-5']
      },
      '& .MuiListItemText-root': {
        marginTop: Tokens.spacing['$sp-2']
      },
      '& .Mui-selected:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '& .Mui-selected': {
        backgroundColor: theme.palette.action.hover
      },
      '& .MuiListItem-gutters': {
        padding: Tokens.spacing['$sp-4'],
        backgroundClip: 'unset'
      },
      '& .MuiIconButton-root': {
        padding: Tokens.spacing['$sp-0']
      },
      '& .MuiList-padding': {
        paddingTop: Tokens.spacing['$sp-0']
      },
      '& .MuiListItem-button:hover ': {
        backgroundColor: 'transparent'
      }
    },
    border: {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    avatarDisplay: {
      marginRight: Tokens.spacing['$sp-4']
    },
    iconSize: {
      color: themePalette.textPrimary,
      '& svg': {
        fontSize: Tokens.spacing['$sp-8-5']
      }
    },
    avatarWrapper: {
      minWidth: 'auto',
      margin: 0
    },
    secondaryAction: {
      top: Tokens.spacing['$sp-2-5'],
      right: 0
    },
    wrappingText: {
      '& p.MuiTypography-root': {
        display: '-webkit-box',
        overflow: 'hidden',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': 2
      }
    },
    customListContainer: {
      height: '100% !important',
    },
    sectionCheckBox: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      '& .Mui-selected': {  
        backgroundColor: `${theme.palette.action.hover} !important`
      },
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      }
    },
    checkboxRole: {
      margin: '10px 0 10px 10px ',
      padding: '0 10px!important'
    }
  };
});

export default useStyles;
